/** Web ADHA booking service backed by the shared API client. */
export {
  bookingService,
  BookingService,
  extractBookingDetails,
  readBookingText,
} from '@/core/api/services/bookingService';
